// Components
import './components/Sidebar.ts';
import './components/Notification.ts';
import './plugin/Bootstrap.ts';
import { Naja } from './plugin/Nette';
document.addEventListener('DOMContentLoaded', () => Naja.initialize({
    history: false,
    forceRedirect: true,
}));
